import { Injectable, Injector } from '@angular/core';
import { ServerService } from "./server.service";
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthPanelService {

  private _server?: ServerService;
  public get server(): ServerService {
    this._server = this._server || this.injector.get<ServerService>(ServerService);
    return <ServerService>this._server;
  };

  constructor(public injector: Injector) { }

  public async isAuthenticated(): Promise<boolean> {
    try {
      const response = await firstValueFrom(this.server.get("api/panel-login-check"));
      return response.authenticated;
    } catch (error) {
      console.error("Erro na comunicação com o servidor de autenticação: ", error);
      return false;
    }
  }

  public async loginPanel(email: string, password: string): Promise<any> {
    try {
      const response = await firstValueFrom(this.server.post("api/panel-login", { email: email, password: password }));
      return response;
    } catch (error) {
      console.error("Erro na comunicação com o servidor de autenticação: ", error);
      return false;
    }
  }

  public async detailUser(): Promise<any> {
    try {
      const response = await firstValueFrom(this.server.get("api/panel-login-detail"));
      return response;
    } catch (error) {
      console.error("Erro na comunicação com o servidor de autenticação: ", error);
      return false;
    }
  }

  public async logoutPanel(): Promise<any> {
    try {
      const response = await firstValueFrom(this.server.get('api/panel-logout'));
      return response;
    } catch (error) {
      console.error("Erro na comunicação com o servidor de autenticação: ", error);
      return false;
    }
  }
}
